import { DeviceAdapter, DeviceTypeType } from "@validereinc/domain";
import { useEffect, useState } from "react";

/**
 * @deprecated use useListDeviceTypes
 */
const useDeviceTypes = (): [DeviceTypeType[], string] => {
  const [deviceTypes, setDeviceTypes] = useState<DeviceTypeType[]>([]);
  const [loadingState, setLoadingState] = useState("loading");

  useEffect(() => {
    DeviceAdapter.types
      .getList()
      .then((data) => {
        setDeviceTypes(data.data);
        setLoadingState("loaded");
      })
      .catch((error) => {
        console.error(error);
        setLoadingState("error");
      });
  }, []);

  return [deviceTypes, loadingState];
};

export default useDeviceTypes;
